import { useQuery } from '@tanstack/react-query';
import { mobileApi, MobileQuickAction } from '../../services/api/mobile.api';
import { useAuth } from '../../contexts/AuthContext';

export const useMobileQuickActions = () => {
  const { isAuthenticated } = useAuth();
  
  const { data, isLoading, error } = useQuery({
    queryKey: ['mobile-quick-actions'],
    queryFn: async () => {
      try {
        return await mobileApi.getQuickActions();
      } catch (e: any) {
        const status = e?.response?.status || e?.details?.status;
        if (status === 404 || status === 401) {
          return [] as MobileQuickAction[];
        }
        throw e;
      }
    },
    staleTime: 60_000,
    enabled: isAuthenticated, // Выполняем запрос только если пользователь авторизован
    retry: (failureCount, error: any) => {
      // Не повторяем запрос при 401 или 404 ошибках
      const status = error?.response?.status || error?.details?.status;
      if (status === 401 || status === 404) {
        return false;
      }
      return failureCount < 2;
    }
  });

  const actions: MobileQuickAction[] = (data as any)?.data || data || [];
  return { actions, isLoading, error };
};

export default useMobileQuickActions;


